import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
import Layout from "@/Layout";

// 防止连续点击多次路由报错
let routerPush = VueRouter.prototype.push;
let routerReplace = VueRouter.prototype.replace;
// push
VueRouter.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push(location) {
    return routerReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
    mode: 'hash', // 使用 hash 模式
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/redirect',
            component: Layout,
            hidden: true,
            children: [
                {
                    path: '/redirect/:path(.*)',
                    component: () => import('@/views/redirect')
                }
            ]
        },
        {
            path: '/404',
            component: () => import('@/views/error/404'),
            hidden: true
        },
        {
            path: '/401',
            component: () => import('@/views/error/401'),
            hidden: true
        },
        {
            path: '',
            component: Layout,
            redirect: 'index',
            children: [
                {
                    path: 'index',
                    component: () => import('@/views/index'),
                    name: 'Index',
                    meta: { title: '首页'}
                },
                {
                    path: 'group/:id',
                    component: () => import('@/views/group/index'),
                    name: 'Group',
                    meta: { title: '集团概况'}
                },
                {
                    path: 'news/:categoryId/:id',
                    component: () => import('@/views/news/index'),
                    name: 'News',
                    meta: { title: '新闻中心'}
                },
                {
                    path: 'newsDetail',
                    component: () => import('@/views/news/detail'),
                    name: 'NewsDetail',
                    meta: { title: '新闻中心'}
                },
                {
                    path: 'notice/:id',
                    component: () => import('@/views/notice/index'),
                    name: 'Notice',
                    meta: { title: '公示公告'}
                },{
                    path: 'hr/:id',
                    component: () => import('@/views/hr/index'),
                    name: 'Hr',
                    meta: { title: '人力资源'}
                },{
                    path: 'partyBuilding/:id',
                    component: () => import('@/views/partyBuilding/index'),
                    name: 'PartyBuilding',
                    meta: { title: '党建纪检'}
                },{
                    path: 'search',
                    component: () => import('@/views/search/index'),
                    name: 'Search',
                    meta: { title: '搜索'}
                },{
                    path: 'info/:categoryId/:id',
                    component: () => import('@/views/aboutUs/index'),
                    name: 'Info',
                    meta: { title: '关于我们'}
                },{
                    path: 'supplier',
                    component: () => import('@/views/supplier/index'),
                    name: 'Supplier',
                    meta: { title: '供应商'}
                },{
                    path: 'supplierLogin',
                    component: () => import('@/views/supplier/login'),
                    name: 'SupplierLogin',
                    meta: { title: '供应商邓丽'}
                },
            ]
        },
    ]
});

export default router;
